import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Card, CardImage, Text } from '@blueprint/ui';
import { Heading5 } from '@blueprint/heading';
import {
    CardImagePlaceholder,
    PropertyImage
} from 'shared/components/listing-data/listing-image';
import { TagWrapper } from 'shared/components/listing-data/lifecycle-tag/LifecycleTag/LifecycleTag.styles';
import { FeatureList } from 'shared/components/listing-data/listing-features';

export const WidgetWrapper = styled('div')(
    ({ theme: { spacing, mq } }) => css`
        ${mq.medium} {
            margin-top: ${spacing['spacing-6']};
        }
    `
);

export const HeadingRow = styled('div')(
    ({ theme: { spacing } }) => css`
        margin-left: ${spacing['spacing-2']};
        margin-bottom: ${spacing['spacing-3']};
        display: flex;
        align-items: center;
        ${Heading5} {
            margin-left: ${spacing['spacing-2']};
        }
    `
);

export const ScrollRow = styled('div')(
    () => css`
        width: 100%;
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        flex-direction: row;
    `
);

export const CardWrapLink = styled('a')(
    ({ theme: { spacing, focusRing, mq } }) => css`
        margin: ${spacing['spacing-1']} ${spacing['spacing-2']};
        &:nth-of-type(1) {
            margin-top: 0;
        }
        ${mq.medium} {
            margin: ${spacing['spacing-1']};
            &:nth-of-type(1) {
                margin-top: ${spacing['spacing-1']};
            }
        }
        text-decoration: none;
        display: inline;
        :focus {
            box-shadow: ${focusRing};
            outline: 0;
        }
    `
);

export const StyledCard = styled(Card)(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        border-radius: ${theme.borderRadius['400']};
        padding: 0;
        height: 100%;
        width: 17.5rem;

        ${CardImage} {
            margin: 0;
            min-width: 100%;
            height: 100%;
            object-fit: cover;
        }
    `
);

export const Price = styled(Text)(css``);

export const Address = styled(Text)(css``);

export const CardDetails = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        flex: 1;
        min-height: 12rem;
        flex-direction: column;
        align-items: flex-start;
        padding: ${spacing['spacing-2']};
        max-width: 100%;

        ${Price} {
            margin-top: ${spacing['spacing-1']};
            max-width: 100%;
        }
        ${Address} {
            margin-top: ${spacing['spacing-1']};
            white-space: normal;
            max-width: 100%;
        }
        ${FeatureList} {
            margin-top: auto;
            padding-top: ${spacing['spacing-2']};
            padding-bottom: ${spacing['spacing-1']};
        }
    `
);

export const FlexColumn = styled('div')(
    () => css`
        display: flex;
        flex-direction: column;
    `
);

export const StyledMiniCard = styled('div')(
    ({ theme: { colors, spacing, borderRadius } }) => css`
        position: relative;
        display: flex;
        flex-direction: row;
        border-radius: ${borderRadius['300']};
        border: solid 1px ${colors['graphic-divider']};
        height: 6.25rem;

        ${MiniCardDetails} {
            flex: 1;
        }

        ${TagWrapper} {
            z-index: 1;
            bottom: ${spacing['8px']};
            left: ${spacing['8px']};
            margin: 0;
            max-width: 7rem;
            overflow: hidden;
            position: absolute;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        ${PropertyImage} {
            width: 9.375rem;
            @media screen and (max-width: 380px) {
                width: 7.5rem;
            }
            height: 100%;

            ${CardImage}, ${CardImagePlaceholder} {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                margin: 0;
                height: 100%;
                object-fit: cover;
                object-position: center center;
            }
        }
    `
);

export const MiniCardDetails = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: ${spacing['spacing-1']};
        ${Address} {
            margin-top: ${spacing['micro-spacing-2']};
        }
        ${FeatureList} {
            margin-top: auto;
            padding-top: ${spacing['micro-spacing-2']};
            padding-bottom: ${spacing['spacing-1']};
        }
    `
);

export const StyledLinkWrapper = styled('div')<{
    isCentred: boolean;
}>(
    ({ isCentred, theme: { spacing } }) => css`
        display: flex;
        justify-content: ${isCentred ? 'center' : 'flex-start'};
        svg {
            margin-left: ${spacing['spacing-1']};
        }
    `
);
